// extracted by mini-css-extract-plugin
export default {"styleEffectsPanel":"Custom_styleEffectsPanel__I010G","hideSection":"Custom_hideSection__I1Vew"};